import { useDefaultObservable, useStateFromUiEvents } from '@/utils/event'
import { ReactNode, useRef } from 'react'

declare global {
  interface AppUIEventMap {
    CheckboxToggle: {
      type: 'CheckboxToggle'
      id: string
    }
  }
}

export function useCheckbox(params: {
  id: string
  label: ReactNode
  storage: Storage
  startingValue: boolean
  disabled: boolean
}) {
  const { id, label, disabled } = params

  const isCheckedRef = useRef(params.startingValue)

  const isChecked$ = useStateFromUiEvents({
    id: `checkbox/${id}`,
    storage: params.storage,
    startingValue: params.startingValue,
    scan: (isChecked, event) => {
      if (event.type === 'CheckboxToggle' && event.id === id) {
        return !isChecked
      }
      return isChecked
    },
  })
  const isChecked = useDefaultObservable(isChecked$)

  // we need the ref for accesing the latest state in closures (stale closure problem)
  // eslint-disable-next-line immutable/no-mutation
  isCheckedRef.current = isChecked

  return { isChecked: isCheckedRef, isChecked$, props: { id, disabled, value: isChecked, label } }
}
